
<!-- <div class="login_details">
  <app-background></app-background>
  <mat-card class="login_card">
    <div class="login_header">Sign In</div>
    <div class="login_header_data">Make your content broadcast easier and simple with sharkify.</div>
    <div class="page_details">
      
      <div class="form_field">
        <mat-form-field appearance="outline" class="login_form_fields">
          <mat-label>Email ID</mat-label>
          <input matInput type="text"  [formControl]="Email" style="vertical-align: top; margin-left: 5px;">
          <mat-icon matSuffix style="color: var(--black-shade);">mail</mat-icon>
          <mat-error *ngIf="!Email.valid">
            {{getEmailError()}} 
          </mat-error>
        </mat-form-field>
      </div>
      <div class="form_field">
        <mat-form-field appearance="outline" class="login_form_fields">
          <mat-label>Password</mat-label>
          <input matInput  [type]="p_hide ? 'password' : 'text'" [formControl]="Password">
          <button mat-icon-button matSuffix (click)="p_hide = !p_hide" [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="p_hide">
            <mat-icon style="color: var(--black-shade);">{{p_hide ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <mat-error *ngIf="!Password.valid">
            {{getPasswordError()}}
          </mat-error>
        </mat-form-field>
      </div> 
        <div *ngIf="ErrorLoggingIn" class="login_error_message">
          {{LoginErrorMessage}}
        </div>
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <div style="display: flex; align-items: center; margin-bottom: 10px;">
            <mat-checkbox [(ngModel)]="RemeberMe"></mat-checkbox>
            <p style="font-family: var(--font); margin: 0;font-size: 15px;" [(ngModel)]="RemeberMe" >Remeber Me</p>
          </div>
          <div style="margin-bottom: 10px;">
            <button class="login_forgot" routerLink="/ForgotPassword">Forgot password?</button>
          </div>
        </div> 
        <div class="submit_button_wrap">
          <button class="login_buttons" type="submit" (click)="signIn()">Sign In</button>
        </div>

        <div class="icon_buttons">
          <button id="google-signin-btn" class="google_signin_btn">
            <img src="assets/google-logo.png" alt="Google Sign-In" class="google-logo" />
          </button> -->
          <!-- /facebook_signin_button -->
          <!-- <button class="facebook_login_button"(click)="signInWithFB()">
            <img style="height: 25px;width: 25px;" src="assets/Facebook.png" />
          </button> -->
          <!-- <div class="g_id_signin"></div>
        </div>

        <div class="submit_button_wrap" style="padding: 10px 0px;">
          <div style="color: var(--black-shade);display: inline;font-family: var(--font);font-size: 18px ;letter-spacing: 1px; " >New to Sharkify ? </div>
           <div class="sigup_button" (click)="signUp()" > Sign Up </div>
        </div>

      </div>
  </mat-card> -->
<!-- </div> -->
<app-header></app-header>
<div class="login_page" style="overflow: hidden;">
  <div class="row">
    <div class="col-md-6" style="padding-top: 5%;">      
    <div class="login_header">Sign In</div>
    <div class="login_header_data">Make your content broadcast easier and simple with sharkify.</div>
    <div style="padding: 0% 10%;">
      <div class="form_field">
        <mat-form-field appearance="outline" class="login_form_fields">
          <mat-label>Email ID</mat-label>
          <input matInput type="text"  [formControl]="Email" style="vertical-align: top; margin-left: 5px;">
          <mat-icon matSuffix style="color: var(--black-shade);">mail</mat-icon>
          <mat-error *ngIf="!Email.valid">
            {{getEmailError()}} 
          </mat-error>
        </mat-form-field>
      </div>
      <div class="form_field">
        <mat-form-field appearance="outline" class="login_form_fields">
          <mat-label>Password</mat-label>
          <input matInput  [type]="p_hide ? 'password' : 'text'" [formControl]="Password">
          <button mat-icon-button matSuffix (click)="p_hide = !p_hide" [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="p_hide">
            <mat-icon style="color: var(--black-shade);">{{p_hide ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <mat-error *ngIf="!Password.valid">
            {{getPasswordError()}}
          </mat-error>
        </mat-form-field>
      </div> 
        <div *ngIf="ErrorLoggingIn" class="login_error_message">
          {{LoginErrorMessage}}
        </div>
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <div style="display: flex; align-items: center; margin-bottom: 10px;">
            <mat-checkbox [(ngModel)]="RemeberMe"></mat-checkbox>
            <p style="font-family: Montserrat; margin: 0;font-size: 14px;" [(ngModel)]="RemeberMe" >Remeber Me</p>
          </div>
          <div style="margin-bottom: 10px;">
            <button class="login_forgot" routerLink="/ForgotPassword">Forgot password?</button>
          </div>
        </div>
        <div class="submit_button_wrap">
          <button class="login_buttons" type="submit" (click)="signIn()">Sign In</button>
        </div>
        <div class="submit_button_wrap" style="padding: 10px 0px;">
          <div style="color: var(--black-shade);display: inline;font-size: 15px;font-family: Montserrat;letter-spacing: 1px; " >New to Sharkify ? </div>
           <div class="sigup_button" (click)="signUp()" > Sign Up </div>
        </div>
        <div class="icon_buttons">
          <button id="google-signin-btn" class="google_signin_btn">
            <img src="assets/google-logo.png" alt="Google Sign-In" class="google-logo" />
          </button>
          <!-- <button class="facebook_login_button"(click)="signInWithFB()">
            <img style="height: 25px;width: 25px;" src="assets/Facebook.png" />
          </button>  -->
          <div class="g_id_signin"></div>
        </div>
    </div>
    </div>
    <div class="col-md-6">
      <picture><img src="assets/login.webp" loading="lazy" alt="Login"  style="width: 100%;"></picture>
    </div>
  </div>
</div>
<app-footer></app-footer>